import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { SettingModel } from '../../../models';
import { SettingsService } from '../../../services';

@Component({
    selector: 'app-account-settings',
    templateUrl: './account-settings.component.html',
    styleUrls: ['../../layout/layout.component.scss']
})
export class AccountSettingsComponent implements OnInit {

    public accountId: number = 0;
    public model: any;
    public isAdminOrUserEditor: boolean;
    public showSpinner: boolean = false;
    public accountSettingsList: any = [];

    constructor(
        private elem: ElementRef,
        private settingService: SettingsService,
        private toastr: ToastsManager,
        private route: ActivatedRoute,
        private router: Router) { }

    public ngOnInit() {
        this.model = new SettingModel();
    }

    public loadData(id?: number) {
        this.showSpinner = true;
        this.accountId = id;
        this.settingService.getAccountSettings(id)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                let data = response.Data ? response.Data : [];
                this.accountSettingsList = data;
            });
    }

    public saveSetting(data) {
        this.showSpinner = true;
        let control = this.elem.nativeElement.querySelector(`#setting-value-${data.ConfigSettingId}`);
        let value = data.InputType != 'checkbox' ? control.value : control.checked;

        this.model.AccountId = this.accountId;
        this.model.Value = value;
        this.model.Name = data.Name;
        this.model.ConfigSettingId = data.ConfigSettingId;

        this.settingService.accountSaveSettings(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                this.loadData(this.model.AccountId);
                this.ngOnInit();
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/components/management/account-settings/account-settings.component.ts